import { useSelector } from 'react-redux';

import { COUNTRY_CODES } from 'constants/address/counties.const';
import { selectCurrentSalonCountryCode } from 'selectors/currentSalon.selectors';
import logger from 'utils/logger.util';
import asObject from 'utils/objects/asObject.util';

const L = logger('useCountryImage');

export const useCountryImage = (imageMap) => {
  const countryCode = useSelector(selectCurrentSalonCountryCode);

  if (!imageMap || typeof imageMap !== 'object' || Array.isArray(imageMap)) {
    L.warn('()', 'imageMap must be a plain object, got:', typeof imageMap, imageMap);
    return undefined;
  }

  if (!countryCode) {
    return imageMap[COUNTRY_CODES.GB];
  }

  if (!(countryCode in asObject(imageMap))) {
    L.warn('()', 'imageMap has not correct keys', imageMap);
    return imageMap[COUNTRY_CODES.GB];
  }

  return imageMap[countryCode];
};
